import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e41c3e52"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "function-help-text",
  "aria-label": "使用说明"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "适合做什么？", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "使用方法", -1))
const _hoisted_4 = { "aria-hidden": "true" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "function-help-note" }, "请以当前页面实际显示的按钮、账号权限和处理结果为准。提交或保存后，查看页面反馈，并在对应列表、明细或设置中重新核对结果。", -1))
const _hoisted_8 = {
  key: 0,
  class: "function-help-video"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    title: _ctx.title + ' · 帮助',
    footer: null,
    width: 860,
    destroyOnClose: true,
    onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      (_ctx.visible)
        ? (_openBlock(), _createBlock(_component_a_tabs, {
            key: 0,
            activeKey: _ctx.activeTab,
            "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "text",
                tab: "使用说明"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("section", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("p", null, _toDisplayString(_ctx.description || '查看本页信息，处理当前账号可使用的管理功能。'), 1),
                    _hoisted_3,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageSteps, (section, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: section.title,
                        class: "function-help-step"
                      }, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(index + 1), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, _toDisplayString(section.title), 1),
                          (section.steps?.length === 1)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(section.steps?.[0]), 1))
                            : (_openBlock(), _createElementBlock("ol", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.steps, (step) => {
                                  return (_openBlock(), _createElementBlock("li", { key: step }, _toDisplayString(step), 1))
                                }), 128))
                              ]))
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageNotes, (section) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: section.title
                      }, [
                        _createElementVNode("h3", null, _toDisplayString(section.title), 1),
                        _createElementVNode("p", null, _toDisplayString(section.content), 1)
                      ], 64))
                    }), 128)),
                    _hoisted_7
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "video",
                tab: "帮助视频"
              }, {
                default: _withCtx(() => [
                  (_ctx.activeTab === 'video' && _ctx.safeUrl)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(), _createElementBlock("video", {
                          key: _ctx.safeUrl,
                          src: _ctx.safeUrl,
                          controls: "",
                          playsinline: "",
                          preload: "metadata",
                          onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.failed = true)),
                          onLoadeddata: _cache[1] || (_cache[1] = ($event: any) => (_ctx.failed = false))
                        }, null, 40, _hoisted_9)),
                        (_ctx.failed)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "视频暂时无法播放，请检查网络或联系管理员核对视频地址。"))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.activeTab === 'video')
                      ? (_openBlock(), _createBlock(_component_a_empty, {
                          key: 1,
                          description: "暂无帮助视频，请查看使用说明。"
                        }))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}